import ICategory from "@models/ICategory";
import { useNavigate } from "react-router-dom";
import "./EcommerceHomeCategoryListView.scss";

type Props = {
    category: ICategory;
};

export const EcommerceHomeCategoryListView = (props: Props) => {
    const navigate = useNavigate();

    const selectHomeCategory = () => {
        navigate(`/ecomm?category=${props.category.guid}`);
    };

    return (
        <div className={"EcommerceHomeCategoryListView"}>
            <div className="card text-center" onClick={selectHomeCategory}>
                <div className={"card-body"}>
                    <div className="card-title">{props.category.name}</div>
                </div>
            </div>
        </div>
    );
};
